export const setLocalDate = (dateString) => {
  const oldDate = new Date(dateString);
  const newDate = new Date(oldDate.getTime() + oldDate.getTimezoneOffset() * 60 * 1000);
  const offset = oldDate.getTimezoneOffset() / 60;
  const hours = oldDate.getHours();
  return newDate.setHours(hours - offset);
};
